import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Subtract16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M1.7747 7.25C1.34685 7.25 1 7.58579 1 8C1 8.41421 1.34685 8.75 1.7747 8.75H14.2253C14.6532 8.75 15 8.41421 15 8C15 7.58579 14.6532 7.25 14.2253 7.25H1.7747Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
